module.exports = __webpack_public_path__ + "img/bubble_red_2.b46e8305.png";